export default __webpack_public_path__ + "static/media/img-0715-estonia-full-face.ab7df42e.png";